import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to fetch award feedback for a given award
 * Returns the selection reasons and comments provided by the client
 */
export function useAwardFeedback(awardId: string | undefined) {
  return useQuery({
    queryKey: ['award-feedback', awardId],
    queryFn: async () => {
      if (!awardId) return null;
      
      const { data, error } = await supabase
        .from('rfq_award_feedback')
        .select('*')
        .eq('award_id', awardId)
        .maybeSingle();
      
      if (error) throw error;
      return data;
    },
    enabled: !!awardId,
  });
}
